<template>
    <div class="competition-overlay" @click.self="$router.back()">
        <div class="competition-overview" @click.self="$router.back()">
            <TournamentOverview :tournament-id="competitionId" />
        </div>
    </div>
</template>

<script>
import TournamentOverview from '../../../views/Tournament/views/TournamentOverview.vue';

export default {
    name: 'CompetitionOverview',
    components: { TournamentOverview },
    props: {
        competitionId: {
            type: Number,
            required: true
        }
    },
    created() {
        console.log('CompetitionOverview created with competitionId:', this.competitionId);
        document.documentElement.style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.documentElement.style.overflow = '';
    }
}
</script>
<style lang="scss">
.competition-overlay {
    .competition-overview {
        .tournament-rank-view{
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
}
</style>

<style scoped lang="scss">
.competition-overlay {
    position: fixed;
    z-index: 3;
    inset: 0;
    width: 100vw;
    height: 100vh;

    .competition-overview {
        margin: 0 auto;
        height: 100%;
        background-color: #f8f9fa;
        overflow-y: auto;
        padding: 40px 60px 40px 118px;
        @media (max-width: 960px) {
            padding: 40px 60px 40px 60px;
        }
        .tournament-rank-view{
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
    
}

/* Transición (fade) */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>